import { API, graphqlOperation } from "aws-amplify";

import { getJobRoleQuery } from "./graphql/queries";

const getJobRole = (id) =>
  API.graphql(graphqlOperation(getJobRoleQuery, { id }));

export default getJobRole;
